module.exports = __webpack_public_path__ + "media/assets/better_best-824899a6c7e378b88ff9e357fb624bb1.png";